/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { brand } from "../../../config/appData";
import { useAppDispatch, useMailData } from "../../../Utility";
import { onSendMail, onSendMailReset } from "../../../Store/Slices/mailSlice";
import "./ForgotPasswordPage.css";

function ForgotPasswordPage() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const mailData = useMailData();

  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const isLoading = mailData?.sendLoading ?? false;
  const apiError = mailData?.sendError ? mailData?.sendMessage : null;
  const isSuccess =
    mailData?.sendStatusCode === 200 ||
    mailData?.sendStatusCode === "200" ||
    mailData?.sendStatusCode === 201 ||
    mailData?.sendStatusCode === "201";

  useEffect(() => {
    dispatch(onSendMailReset());
  }, [dispatch]);

  useEffect(() => {
    if (isSuccess) {
      setSubmitted(true);
      dispatch(onSendMailReset());
    }
  }, [isSuccess]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");
    const trimmed = email.trim();
    if (!trimmed) {
      setError("Please enter your email address.");
      return;
    }
    if (!/\S+@\S+\.\S+/.test(trimmed)) {
      setError("Please enter a valid email address.");
      return;
    }
    dispatch(
      onSendMail({
        to: trimmed,
        type: "resetpassword",
      }),
    );
  };

  return (
    <div className="forgot-password-page">
      <div className="forgot-password-card">
        <Link
          to="/login"
          className="forgot-password-back"
          aria-label="Back to login"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <line x1="19" y1="12" x2="5" y2="12" />
            <polyline points="12 19 5 12 12 5" />
          </svg>
          Back to login
        </Link>
        <div className="forgot-password-header">
          <div className="forgot-password-brand" onClick={() => navigate("/")}>
            <span className="forgot-password-logo">{brand.logoIcon}</span>
            <span className="forgot-password-name">{brand.name}</span>
          </div>
          <h1 className="forgot-password-title">Forgot password?</h1>
          <p className="forgot-password-subtitle">
            Enter your email and we&apos;ll send you a link to reset your
            password.
          </p>
        </div>
        {!submitted ? (
          <form className="forgot-password-form" onSubmit={handleSubmit}>
            <div className="forgot-password-group">
              <label htmlFor="forgot-email" className="forgot-password-label">
                Email address
              </label>
              <input
                type="email"
                id="forgot-email"
                className="forgot-password-input"
                placeholder="you@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoFocus
              />
              {error && <span className="forgot-password-error">{error}</span>}
              {apiError && (
                <span className="forgot-password-error">{apiError}</span>
              )}
            </div>
            <button
              type="submit"
              className="forgot-password-btn"
              disabled={isLoading}
            >
              {isLoading ? "Sending..." : "Send reset link"}
            </button>
          </form>
        ) : (
          <div className="forgot-password-success">
            <p className="forgot-password-success-text">
   The link has been sent to the email <strong>{email}</strong>. Please check your email for the link.
            </p>
            <Link
              to="/login"
              className="forgot-password-btn forgot-password-btn-secondary"
            >
              Back to login
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}

export default ForgotPasswordPage;
